import React from 'react';
import { string, func, oneOf } from 'prop-types';
import classnames from 'classnames/bind';
import { renderLinks } from '../../common';

import styles from './HotspotB.css';
import textStyles from '../../common.css';

const cx = classnames.bind(styles);

const HotspotB = ({ title, description, link, onClick, colorScheme }) => {

  const links = [
    {
      colorScheme,
      onClick,
      class: styles.link,
      text: link,
      icon: { direction: 'right', name: 'arrow-right', type: '20' },
      size: 'l',
      minWidth: 1367
    },
    {
      colorScheme,
      onClick,
      class: styles.link,
      text: link,
      icon: { direction: 'right', name: 'arrow-right', type: '20' },
      size: 'm',
      minWidth: 281,
      maxWidth: 1366
    },
    {
      colorScheme,
      onClick,
      class: styles.link,
      text: link,
      icon: { direction: 'right', name: 'link-arrow-right-17', type: 'other' },
      size: 's',
      maxWidth: 280
    }
  ];

  return (
    <div className={classnames(colorScheme, styles.wrapper)}>
      <div className={styles.container}>
        <h1 className={classnames(textStyles.title, cx('title', { 'v2': !description }))}>
          {title}
        </h1>

        {
          description &&
            <p className={classnames(textStyles.description, styles.description)}>{description}</p>
        }

        { renderLinks(links) }

      </div>
    </div>
  );
};

HotspotB.propTypes = {
  colorScheme: oneOf([
    'lb01',
    'lb02',
    'lb03',
    'lb04',
    'lb05',
    'lb06',
    'lb07',
    'lb08'
  ]),
  description: string,
  link: string.isRequired,
  onClick: func,
  title: string.isRequired
};

HotspotB.defaultProps = {
  colorScheme: 'lb01'
};

HotspotB.displayName = 'HotspotB';

export default HotspotB;


// WEBPACK FOOTER //
// ./src/uis/components/Hotspots/Landing/HotspotB/HotspotB.js